import { TranslationKeys } from 'types/TranslationKeys'

export interface LinksProps {
  t: (key: TranslationKeys) => string
}

export const useLinks = (props: LinksProps) => {
  return {
    ...props,
  }
}
